import { useQuery } from "@tanstack/react-query";
import UserNotification from "util/UserNotification";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import { onError } from "util/conditional/onError";
import EnterpriseApiRoutes from "common/ApiRoutes";
import { LICENSE_SUBJECTS } from "license/constants";
const notifyUnlessMissing = (error) => {
  var _a, _b, _c, _d;
  if (((_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.status) === 404) {
    return;
  }
  const errorMessage = (_d = (_c = (_b = error == null ? void 0 : error.additional) == null ? void 0 : _b.body) == null ? void 0 : _c.message) != null ? _d : error == null ? void 0 : error.message;
  UserNotification.error(`Fetching Security license failed: ${errorMessage}`, "Could not retrieve Security license");
};
const fetchSecurityLicenseStatus = () => onError(
  fetch("GET", qualifyUrl(EnterpriseApiRoutes.License.validityForSubject(LICENSE_SUBJECTS.security).url)),
  notifyUnlessMissing
);
export const SIGMA_CORRELATION_LICENSE_STATUS_QUERY_KEY = ["sigma-correlation", "security-license-status"];
const useSigmaCorrelationLicenseStatus = () => {
  const { data, isFetching, isError } = useQuery({
    queryKey: SIGMA_CORRELATION_LICENSE_STATUS_QUERY_KEY,
    queryFn: fetchSecurityLicenseStatus,
    retry: false,
    // Non-standard on purpose, mirroring useEventsLicenseStatus: the returned
    // { status, missing, loading } derives from isFetching/isError rather than from
    // `error`, so those props must trigger re-renders. Do not normalize to ['data', 'error'].
    notifyOnChangeProps: ["data", "isFetching", "isError"]
  });
  return {
    status: isError ? null : data != null ? data : void 0,
    missing: isError || !isFetching && data === void 0,
    loading: isFetching
  };
};
export default useSigmaCorrelationLicenseStatus;
